import React from "react";
import CircularProgress from "material-ui/CircularProgress";

export default class CustomCircularProgress extends React.PureComponent {
    render() {
        const {
            size,
            thickness,
            color = "",
            mode = "indeterminate",
            max = 100,
            min = 0,
            value = 0,
            innerStyle = {},
            style = {}
        } = this.props;
        return (
            <CircularProgress
                {...this.props}
                size={size}
                thickness={thickness}
                color={color}
                mode={mode}
                innerStyle={Object.assign({}, innerStyle)}
                style={Object.assign({}, style)}
                max={max}
                min={min}
                value={value}
            />
        );
    }
}
